import BossModel from "@/models/BossModel";
import UserGroup from "@/models/User/UserGroup/UserGroup";
import Role from "@/models/User/Role/Role";
import UserUserRole from "@/models/User/UserUserRole";
import UserBuddy from "@/models/User/UserBuddy";
import SaleTarget from "@/models/User/SaleTarget/SaleTarget";
import Vue from "vue";
import PublicImage from "@/models/PublicImage/PublicImage";
import Connected from "@/models/User/Connected";
import ExpertiseCountry from "@/models/User/ExpertiseCountry/ExpertiseCountry";
import constants from "@/constants";
import moment from "moment/moment";
import CountryProficiency from "@/models/User/CountryProficiency/CountryProficiency.js";

export default class User extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'user';

    /**
     *
     * @type {string}
     */
    static entity = 'users';

    static fields() {
        return {
            id: this.number(null).nullable(),
            permissions: this.attr([]),
            name: this.attr(null),
            firstname: this.attr(null),
            lastname: this.attr(null),
            email: this.attr(null),
            platinum_email: this.attr(null),
            telephone: this.attr(null),
            function: this.attr(null),
            is_active: this.boolean(true),
            is_api: this.boolean(false),
            is_developer: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            deleted_at: this.attr(null),
            personal_signature: this.attr('Met mijn kennis en ervaring zal ik er alles aan doen om uw droomreis werkelijkheid te laten worden.'),
            user_group_id: this.number(null),
            session_token: this.attr(null),
            default_revenue_group_id: this.number(null).nullable(),
            afas_shortcode: this.attr(null),
            broadsoft_internal: this.attr(null),
            birth_date: this.attr(null),
            mobile_number: this.attr(null),
            square_public_image_id: this.number(null).nullable(),
            user_team_id: this.number(null).nullable(),
            xelion_internal: this.attr(null),
            xelion_external: this.attr(null),
            platinum_xelion_external: this.attr(null),
            microsoft_eid: this.attr(null),
            xelion_user_eid: this.attr(null),
            changelog_last_seen_at: this.attr(null),
            job_title: this.attr(null),
            group: this.belongsTo(UserGroup, 'user_group_id'),
            roles: this.belongsToMany(Role, UserUserRole, 'user_id', 'user_role_id'),
            buddies: this.belongsToMany(User, UserBuddy, 'user_id', 'buddy_id'),
            squarePublicImage: this.belongsTo(PublicImage, 'square_public_image_id'),
            saleTargets: this.hasMany(SaleTarget, 'user_id'),
            connected: this.hasOne(Connected, 'user_id'),
            expertiseCountries: this.hasMany(ExpertiseCountry, 'user_id'),
            countryProficiencies: this.hasMany(CountryProficiency, 'user_id'),
        }
    }

    phoneNumber() {
        if (this.xelion_external) {
            let phone = this.xelion_external.replace('0031', '0');
            const position = 4;
            return [phone.slice(0, position), '-', phone.slice(position)].join('');
        }

        return constants.phoneNumberShort;
    }

    isBirthday() {
        let birth = moment(this.birth_date);
        let now = moment();

        return birth.month() === now.month() && birth.date() === now.date();
    }

    /**
     *
     * @param params
     * @returns {PromiseLike<[]> | Promise<[]> | *}
     */
    static search(params = {}) {
        return this.api()
            .filtered(params.filters)
            .limit(20)
            .get().then((data) => {
                let instances = [];
                for (let key in data) {
                    instances.push(new User(data[key]));
                }
                return instances;
            });
    }

    /**
     *
     * @returns {*}
     */
    static fetchAllForSelect() {
        return this.api()
            .limit(0)
            .get(true);
    }

    /**
     *
     * @param id
     * @returns {*}
     */
    static loadWithPublicImages() {
        return this.api().with(['squarePublicImage']).get(true);
    }

    /**
     *
     * @param key
     * @returns {*}
     * @constructor
     */
    HasPermission(key) {
        return this.permissions.includes(key);
    }

    /**
     *
     * @returns {User}
     */
    static loggedInUser() {
        return this.find(Vue.prototype.$loggedInUserId);
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Group() {
        return this.getRelated('group');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    SquarePublicImage() {
        return this.getRelated('squarePublicImage');
    }

    static fetchMicrosoftEid(email) {
        return this.api().action('microsoft/eid').filtered({email: email}).getSingle(false);
    }
}
